module.exports = "/packs/images/homepage/facilities/spa_tablet~865c2b6a0b4d7e6e2c93b369970a197a.jpg";